<div
  class="wellbeing-helpline-container"
  [ngClass]="{ 'alternate-colours': alternateColours }"
>
  <div class="wellbeing-text-container">
    <h2>{{ helplineData.title }}</h2>
    <p>{{ helplineData.excerpt }}</p>
  </div>
  <div class="helpline-numbers-container">
    <a
      href="{{
        userAccommodation.override_uk_number
          ? 'tel:' + userAccommodation.override_uk_number
          : 'tel:' + helplineData.uk_number
      }}"
      >{{
        userAccommodation.override_uk_number
          ? userAccommodation.override_uk_number
          : helplineData.uk_number
      }}</a
    >
    <ng-container *ngIf="userAccommodation.show_ireland_line">
      <a
        class="ireland-number"
        href="{{
          userAccommodation.override_ire_number
            ? 'tel:' + userAccommodation.override_ire_number
            : 'tel:' + helplineData.ireland_number
        }}"
        >{{
          userAccommodation.override_ire_number
            ? userAccommodation.override_ire_number
            : helplineData.ireland_number
        }}</a
      >
    </ng-container>
  </div>
</div>
